import styled from 'styled-components';

const Section = styled.div`
  padding-top: 3rem;
  padding-bottom: 3rem;
  align-items: center;
`;

export { Section };